import { useStyles } from "./MyActionPlans.styles";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import NoData from "components/NoData/NoData.view";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import useMyActionPlansColumns from "./useMyActionPlansColumns";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { MainTable } from "components/MainTable";
import { Card, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { RCADashboardContext } from "contexts/RCADashboardContext/RCADashboardContext";

const MyActionPlans = () => {
    const classes = useStyles();
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const {
        handleRequestSortActionPlans,
        loadingUserActionPlans,
        orderActionPlans,
        orderByActionPlans,
        pageActionPlans,
        rowsPerPageActionPlans,
        setUserActionPlanFilters,
        userActionPlanFilters,
        userActionPlans,
        userActionPlansError,
        handleChangeRowsPerPageActionPlans,
        handleChangePageActionPlans,
        totalCountActionPlans,
    } = useContext(RCADashboardContext);
    const tableColumns = useMyActionPlansColumns() as unknown as IMainTableColumn[];

    return (
        <Card className={mainClasses.contentCard}>
            <div className={mainClasses.contentCardHeader}>
                <span className={mainClasses.contentCardTitleCapitalized}>
                    {t("rca.rca_dashboard.my_action_plans")}
                </span>
                <div className={mainClasses.contentCardActions}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    value={true}
                                    color="info"
                                    onChange={(_, checked) => {
                                        setUserActionPlanFilters({ ...userActionPlanFilters, showCompleted: checked });
                                    }}
                                />
                            }
                            label={t("rca.rca_dashboard.show_completed")}
                        />
                    </FormGroup>
                </div>
            </div>
            <div className={mainClasses.contentCardContent}>
                {userActionPlans && !userActionPlans.length && (
                    <NoData className={mainClasses.contentNoData} title={t("data.no_data_short")} />
                )}
                {userActionPlans && !!userActionPlans.length && (
                    <MainTable
                        maxHeight={false}
                        customStyle={`${mainClasses.contentTable} ${classes.mainTable}`}
                        paperElevation={0}
                        paperCustomStyle={mainClasses.contentTablePaperMyDashboard}
                        columns={tableColumns}
                        tableCellCustomStyle={mainClasses.contentTableCell}
                        rows={!loadingUserActionPlans && !userActionPlansError ? userActionPlans : []}
                        loading={loadingUserActionPlans}
                        tableOperationsValues={{
                            order: orderActionPlans,
                            orderBy: orderByActionPlans,
                            page: pageActionPlans,
                            rowsPerPage: rowsPerPageActionPlans,
                        }}
                        customStyleTypography={{ width: "100%" }}
                        handleRequestSortParent={handleRequestSortActionPlans}
                        handleChangePageParent={handleChangePageActionPlans}
                        handleChangeRowsPerPageParent={handleChangeRowsPerPageActionPlans}
                        pagination
                        count={totalCountActionPlans}
                        querySorted={!!orderByActionPlans}
                        onRowClick={(row: { action_plan_id?: number }) => {
                            navigate(
                                `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_ACTION_PLANS.ROOT}/${row.action_plan_id}`,
                                {
                                    state: {
                                        from: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}`,
                                    },
                                },
                            );
                        }}
                    />
                )}
            </div>
        </Card>
    );
};

export default MyActionPlans;
